import React from 'react'
import { useRouter } from 'next/router'
import Redirect from '@components/redirect'

const CoachingCenterPage = () => {
  const router = useRouter()
  const slug = 'pga-coaching-center-at-pga-frisco'

  if (router.pathname === '/coachingcenter') {
    return <Redirect to={`/${slug}`} />
  }

  return null
}

export default CoachingCenterPage
